import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import H1 from "../H1";
import H2 from "../H2";
import { EMOJI, OPEN_QANDA, POLL, calculatePercentage } from "../QandA";
import { checkForOverride } from "../helpers/theme";
import { QRCodeSVG } from "qrcode.react";


export default function InteractionJoin  ({ cue }) {
  let { projectId } = useParams()
	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText
	);
  const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);

  const baseTheme = useSelector((state) =>
  cue.theme
    ? state?.main?.projects?.[projectId]?.themes?.[cue.theme]
    : state?.main?.projects?.[projectId]?.themes?.[selectedProject?.theme]
	);
	const baseThemeId = cue.theme ? cue.theme : projectId?.theme;

  console.log(dynamicText)
  const url = `h2r.li/code • ${dynamicText['qanda.code']}`
  const urlQR = `h2r.li/code/${dynamicText['qanda.code']}`
  return (
    <div className="w-full p-s4 flex gap-6 justify-between items-center">
      <div className="flex flex-col justify-start items-start text-left">
        <H1 cue={cue} text={cue.text || 'Join our Q&A here'} baseTheme={baseTheme} baseThemeId={baseThemeId} />
        <H2 cue={cue} text={cue.url || `${url}`} baseTheme={baseTheme} baseThemeId={baseThemeId} />
      </div>

      <QRCodeSVG
        value={urlQR}
					style={{
						height: `12vw`,
						width: `12vw`,
						aspectRatio: `1/1`,
						padding: ".5vw",
						backgroundColor: cue.bgColour || "white",
					}}
					bgColor={cue.bgColour || "white"}
					fgColor={cue.fgColour || "black"} />
    </div>
  )
}
